const A = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
const L = A.length;

function getC(): any {
  const g: any = globalThis as any;
  const c = g.crypto || g.msCrypto;
  if (c?.getRandomValues) return c;
  try {
    const r = (0, eval)('require') as any;
    return r?.('node:crypto')?.webcrypto;
  } catch {
    return undefined;
  }
}

export function generateId(n = 16): string {
  if (!Number.isFinite(n) || n <= 0) throw new Error('length must be > 0');
  const c = getC();
  let s = '';
  if (c && typeof Uint8Array !== 'undefined') {
    const buf = new Uint8Array(Math.max(64, n * 2));
    for (let i = 0; i < n; ) {
      c.getRandomValues(buf);
      for (const b of buf) {
        const v = b & 63;      // 0..63
        if (v < L) {           // reject 62,63 to avoid bias
          s += A[v];
          if (++i === n) break;
        }
      }
    }
    return s;
  }
  for (let i = 0; i < n; i++) s += A[(Math.random() * L) | 0];
  return s;
}
